import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { RegisterComponent } from './register/register.component';
import { SettingsComponent } from './settings/settings.component';
import { AdventureComponent } from './adventure/adventure.component';
import { StravaComponent } from './strava/strava.component';
import { ConfirmemailComponent } from './confirmemail/confirmemail.component';
import { PremiumComponent } from './premium/premium.component';
import { RetrieveComponent } from './retrieve/retrieve.component';
import { StatusComponent } from './status/status.component';
import { ContactComponent } from './contact/contact.component';
import { AuthGuard, AuthGuardHomepage } from './guard/auth-guard.service';
import { PrivacyComponent } from './privacy/privacy.component';
import { ShellComponentComponent } from './shell-component/shell-component.component';
import { HomepageComponent } from './homepage/homepage.component';
import { TermsComponent } from './terms/terms.component';
import { PageNotFoundComponent } from './pagenotfound/page-not-found.component';

const appRoutes: Routes = [
  { path: '', component: HomepageComponent, canActivate: [AuthGuardHomepage] },
  {
    path: '',
    component: ShellComponentComponent,
    children: [
      // { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
      // { path: 'login', component: LoginComponent },
      // { path: 'register', component: RegisterComponent },
      // { path: 'settings', component: SettingsComponent, canActivate: [AuthGuard]  },
      // { path: 'adventure', component: AdventureComponent, canActivate: [AuthGuard]  },
      // { path: 'privacy', component: PrivacyComponent },
      // { path: 'contact', component: ContactComponent },
      // { path: 'confirmation', component: ConfirmemailComponent },
      // { path: 'premium', component: PremiumComponent, canActivate: [AuthGuard] },
      // { path: 'terms', component: TermsComponent },
      // { path: 'status', component: StatusComponent, canActivate: [AuthGuard]  },
      // { path: 'retrieve', component: RetrieveComponent },
      // { path: 'strava/auth', component: StravaComponent, canActivate: [AuthGuard] }
    ],
  },
  { path: '*', component: HomepageComponent },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
